import { GetStaticPaths, GetStaticProps } from 'next';
import React from 'react';
import {
  BlockRenderer,
  getAllContentPagePaths,
  getContentPage,
} from 'helpers/umbracoApi';
import { ContentPage } from 'types/umbraco';
import { getSharedPageProps } from 'components/Layout';
import { HeadMeta } from 'components/HeadMeta';

export default function Page({ blocks, meta }: ContentPage): JSX.Element {
  return (
    <>
      <HeadMeta {...meta} />
      <BlockRenderer blocks={blocks} />
    </>
  );
}
export const getStaticProps: GetStaticProps = async ({ params }) => {
  const sharedPageProps = await getSharedPageProps();
  const path = Array.isArray(params.slug)
  ? params.slug.join('/')
  : params.slug.toString();

  
  const contentPage = await getContentPage(path);
  
  return {
    revalidate: 20,
    props: {
      slug: params.slug,
      ...contentPage,
      ...sharedPageProps,
    },
  };
};


export const getStaticPaths: GetStaticPaths = async () => {
  const allPages = await getAllContentPagePaths();
  const paths = allPages.map((x) => ({
    params: { slug: x.url.split('/') },
  }));

  return { paths, fallback: false };
};
